import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";

//---------------------------------------------------------------

// GET =>  get  Teachers For School
export const getTeachersForSchool = createAsyncThunk(
  "teacher/getTeachersForSchool",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(
        `${URLS.getTeachersForSchoolURL}/${params?.school_id}`,
        {
          params: {
            page: params.page,
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// Post =>  add  Teachers For School
export const addTeacherForSchool = createAsyncThunk(
  "teacher/addTeacherForSchool",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addTeacherForSchoolURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// Delete =>  Delete  Teachers For School
export const deleteTeacher = createAsyncThunk(
  "teacher/deleteTeacher",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.deleteTeacherURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// PUT =>  editParentData
export const editTeachers = createAsyncThunk(
  "teacher/editTeachers",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.editTeachersURL}/${params?.teacher_id}`,
        params?.data
        // {
        //   headers: {
        //     Accept: "*/*",
        //     "Content-Type": "multipart/form-data",
        //   },
        // }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  teacher Sessions
export const addSessionsForTeacher = createAsyncThunk(
  "teacher/addSessionsForTeacher",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addSessionsTeacherURL, params);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get teacher Sessions
export const getSessionsForTeacher = createAsyncThunk(
  "teacher/getSessionsForTeacher",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getTeacherSessionsrURL, {
        params: {
          teacher_id: params?.teacher_id,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
// Delete =>  Delete  Teachers Session For School
export const deleteTeacherSession = createAsyncThunk(
  "teacher/deleteTeacherSession",
  async (id, thunkAPI) => {
    alert(id)
    try {
      const response = await axios.delete(`${URLS.deleteTeacherSessionURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
